import api from "../api/axios";

export const getEmployeeOnboardingSteps = async (employeeId) => {
  try {
    const response = await api.get(`employee/${employeeId}/onboarding-steps`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Employee Onboarding Steps:", error);
    throw error;
  }
};

export const getOnboardingRequiredDocuments = async (employeeId) => {
  try {
    const response = await api.get(
      `employee/${employeeId}/onboarding-documents`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Onboarding Required Documents:", error);
    throw error;
  }
};

export const submitOnboardingDocuments = async (employeeId, data, stepId) => {
  try {
    const response = await api.post(
      `employee/${employeeId}/documents/${stepId}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error while submit Onboarding Documents:", error);
    throw error;
  }
};

export const getEmployeeOnboardingDocuments = async (employeeId) => {
  try {
    const response = await api.get(`employee/${employeeId}/documents`);
    return response.data;
  } catch (error) {
    console.error("Error fetching Employee Onboarding Documents:", error);
    throw error;
  }
};

export const approveOnboardingDocuments = async (
  employeeId,
  documentId,
  data
) => {
  try {
    const response = await api.post(
      `employee/${employeeId}/documents/${documentId}/approve`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error while approving Onboarding Documents:", error);
    throw error;
  }
};

export const rejectOnboardingDocuments = async (
  employeeId,
  documentId,
  data
) => {
  try {
    const response = await api.post(
      `employee/${employeeId}/documents/${documentId}/reject`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error while rejecting Onboarding Documents:", error);
    throw error;
  }
};

export const updateDocument = async (employeeId, documentId, data) => {
  try {
    const response = await api.put(
      `employee/${employeeId}/documents/${documentId}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Error while updating Onboarding Documents:", error);
    throw error;
  }
};

export const getOnboardingPolicies = async (employeeId) => {
  try {
    const response = await api.get(
      `employee/${employeeId}/onboarding-policies`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Employee Onboarding policies:", error);
    throw error;
  }
};

export const acknowledgeOnBoardingPolicy = async (data) => {
  try {
    const response = await api.post(`onboarding/acknowledge-policy`, data);
    return response.data;
  } catch (error) {
    console.error("Error acknowledge Onboarding policies:", error);
    throw error;
  }
};

export const checkOnboardingStatus = async (employeeId, company_id) => {
  try {
    const response = await api.get(
      `employee/${employeeId}/${company_id}/onboarding-status`
    );
    return response.data;
  } catch (error) {
    console.error("Error updating Onboarding Status:", error);
    throw error;
  }
};
